import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const useSeriesNav = () => {
  const { currentUser } = useCurrentUserContext();

  return !currentUser?.anyUserSportProfile?.proUnlocked;
};
